import { render, staticRenderFns } from "./toRead.vue?vue&type=template&id=48638935"
import script from "./toRead.vue?vue&type=script&lang=js"
export * from "./toRead.vue?vue&type=script&lang=js"
import style0 from "./toRead.vue?vue&type=style&index=0&id=48638935&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports